export const SCHNELLZUGRIFF_ITEMS = [
  { id: 'top-events', icon: '🥇', name: 'Top-Events' },
  { id: 'top-kombis', icon: '🔥', name: 'Top-Kombis' },
  { id: 'todays-matches', icon: '📅', name: 'Spiele von heute' },
  { id: 'category_id:sr:category:30', icon: '🇩🇪', name: 'Deutscher Fußball' },
  { id: 'category_id:sr:category:393', icon: '🌍', name: 'Europäischer Fußball' }
];

export const TOP_WETTBEWERBE = [
  { id: 'tournament:Bundesliga', icon: '🇩🇪', name: 'Bundesliga' },
  { id: 'tournament:2. Bundesliga', icon: '🇩🇪', name: '2. Bundesliga' },
  { id: 'tournament:DFB Pokal', icon: '🇩🇪', name: 'DFB-Pokal' },
  { id: 'tournament:Premier League', icon: '🏴󠁧󠁢󠁥󠁮󠁧󠁿', name: 'Premier League' },
  { id: 'tournament:LaLiga', icon: '🇪🇸', name: 'La Liga' },
  { id: 'tournament:Serie A', icon: '🇮🇹', name: 'Serie A' },
  { id: 'tournament:Ligue 1', icon: '🇫🇷', name: 'Ligue 1' },
  { id: 'tournament:Champions League', icon: '🏆', name: 'Champions League' },
  { id: 'tournament:Europa League', icon: '🏆', name: 'Europa League' }
];

export const TOURNAMENT_ID_MAP: Record<string, string> = {
  'DFB Pokal': 'sr:tournament:47',
  'DFB-Pokal': 'sr:tournament:47',
  '2. Bundesliga': 'sr:tournament:44',
  'Coupe de France': 'sr:tournament:331',
  'Serie A': 'sr:tournament:23',
  'LaLiga': 'sr:tournament:8',
  'La Liga': 'sr:tournament:8',
  'Bundesliga': 'sr:tournament:35',
  'Premier League': 'sr:tournament:17',
  'Ligue 1': 'sr:tournament:16',
  'Champions League': 'sr:tournament:7',
  'Europa League': 'sr:tournament:6',
};

export const SPORT_PRIORITIES: Record<string, string[]> = {
  'Fußball': [
    'Deutschland', 'Germany',
    'Spanien', 'Spain',
    'Italien', 'Italy',
    'England', 'England',
    'Niederlande', 'Netherlands',
    'Schottland', 'Scotland',
    'Portugal', 'Portugal',
    'Norwegen', 'Norway'
  ],
  'Basketball': [
    'USA', 'USA',
    'Deutschland', 'Germany',
    'Brasilien', 'Brazil',
    'Neuseeland', 'New Zealand',
    'Italien', 'Italy',
    'Österreich', 'Austria',
    'Uruguay', 'Uruguay',
    'Indonesien', 'Indonesia'
  ],
  'Eishockey': [
    'USA', 'USA',
    'WM 2026, Herren', 'World Championship', 'World Championship, Men'
  ],
  'Handball': [
    'Deutschland', 'Germany',
    'Spanien', 'Spain',
    'Dänemark', 'Denmark',
    'Norwegen', 'Norway',
    'Polen', 'Poland',
    'Champions League', 'Champions League',
    'International', 'International',
    'Frankreich', 'France'
  ],
  'Tennis': [
    'French Open', 'French Open',
    'ATP', 'ATP',
    'Challenger', 'Challenger',
    'WTA', 'WTA',
    'ITF Damen', 'ITF Women'
  ],
  'American Football': ['USA', 'USA'],
  'Australian Football': ['Australien', 'Australia'],
  'Baseball': ['USA', 'USA', 'Südkorea', 'South Korea', 'Japan', 'Japan'],
  'Boxen': ['Boxen', 'Boxing'],
  'Cricket': ['Indien', 'India'],
  'Darts': ['International', 'International'],
  'Golf': ['Herren', 'Men'],
  'Motorsport': ['Formel 1', 'Formula 1', 'Motorrad', 'Motorcycle', 'Nascar', 'Indy Car'],
  'Radsport': ["Giro d'Italia", 'Tour de France'],
  'Rugby': ['Rugby Union', 'Rugby League']
};

export const TOP_SPORTARTEN = [
  'Fußball',
  'Basketball',
  'Eishockey',
  'Handball',
  'Tennis'
];

export const ALLE_SPORTARTEN = [
  'American Football',
  'Australian Football',
  'Baseball',
  'Basketball',
  'Boxen',
  'Cricket',
  'Darts',
  'Eishockey',
  'Fußball',
  'Golf',
  'Handball',
  'Motorsport',
  'Radsport',
  'Rugby',
  'Tennis'
];
